<template>
  <div class="square-gif-viewer" :class="{showing: visible}">
    <img :src="src" v-on:load="loadedImage" >
    <!-- <div class="small-loader" /> -->
  </div>
</template>

<script>
export default {
  props:{
    src: String
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    loadedImage: async function () {
      this.visible = true
    }
  }
}
</script>

<style>
  .square-gif-viewer{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    overflow:hidden;
    pointer-events: none;
    user-select: none;
    transition:all 0.5s ease;
    z-index:30;
  }

  .square-gif-viewer.showing{
    background-color:#fff;
  }


  .square-gif-viewer img{
    object-fit:cover;
    object-position: center center;
    width:100%;
    height:100%;
    opacity:0;
  }

   .square-gif-viewer.showing img{
    opacity:1;
  }

  .small-loader{
    position:absolute;
    top:35%;
    left:35%;
    width:30%;
    height:30%;
    user-select: none;
    pointer-events: none;
    background-image:url('../../assets/img/spinner.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: auto 50%;
    animation: smallrotateme 3s infinite linear;
    z-index:8;
  }

  .showing .small-loader{
    display:none;
  }

  @keyframes smallrotateme {
    0% {
      transform: rotate(0); 
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
